import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-user-enable',
  templateUrl: './modal-user-enable.component.html',
  styleUrls: ['./modal-user-enable.component.scss']
})
export class ModalUserEnableComponent implements OnDestroy {

  @Output() confirm: EventEmitter<object> = new EventEmitter();
  constructor(public modal: ModalService) { }

  ngOnDestroy() {
    this.modal.close();
  }

  accept() {
    this.modal.close();
    this.confirm.emit();
  }

}
